// import { getRedirectResult } from 'firebase/auth';
// import { useEffect } from 'react';
import // auth,
// signInWithGooglePopup,
// signInWithGoogleRedirect,
// createUserDocumentFromAuth,
'../../utils/firebase/firebase.utils';
import SignUpForm from '../../components/sign-up-form/sign-up-form.component';
import SignInForm from '../../components/sign-in-form/sign-in-form.component';
import './authentication.styles.scss';

const Authentication = () => {
  // useEffect(() => {
  //   const effectAsyncHandler = async () => {
  //     const response = await getRedirectResult(auth);
  //     if (response) {
  //       const userDocRef = createUserDocumentFromAuth(response.user);
  //     }
  //     console.log(response);
  //   };
  //   effectAsyncHandler();
  // }, []);

  return (
    <div className='authentication-container'>
      {/* <h1>Sign in page</h1> */}
      {/* <button onClick={logGoogleUser}>Sign in with Google popup</button> */}
      {/* <button onClick={signInWithGoogleRedirect}>
        Sign in with Google redirect
      </button> */}
      <SignInForm />
      <SignUpForm />
    </div>
  );
};

export default Authentication;
